import colors from './theme/tebraColors';

export { internal, colorScale } from './theme/tebraColors';
export { default as defaults } from './theme/tebraDefaults';

export default colors;
